import cn from 'classnames';
import { useState } from 'react';
import AnimateArrow from '../../Buttons/AnimateArrow';
import H3 from '../../WrapsStyle/H/H3';
import Row from '../Row';
import styles from './styles.module.scss';
import Button from '../../Buttons/Button';

const WhiteBlock = ({
  className,
  minimize = false,
  title = '',
  title_bold = '',
  children,
  left = false,
  openBlock = true,
  ...props
}) => {
  const [open, changeOpen] = useState(openBlock);

  return (
    <div
      className={cn(styles.white_block, minimize && !open && styles.hide_block, className, props.styles)}
      style={props.style}
    >
      <Row style={{alignItems: 'flex-start'}}>
        {minimize && (
          <Button className={left ? styles.button_open_left : styles.button_open_right} onClick={() => changeOpen(!open)}>
            <AnimateArrow isOpen={!open} />
          </Button>
        )}
        {title.length > 0 && (
          <H3 style={{ marginBottom: '30px' }}>
            {title} <span style={{ fontWeight: '600' }}>{title_bold}</span>
          </H3>
        )}
      </Row>

      {children}
    </div>
  );
};

export default WhiteBlock;
